export function Logo({
  className,
  variant = 'default'
}: {
  className?: string
  variant?: 'default' | 'white'
}) {
  const lettersFill = variant === 'default' ? '#233041' : '#FFF'
  return (
    <svg viewBox="0 0 107 24" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
      <g clipPath="url(#clip0_143_305)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M50.834 9.58227C52.456 8.87771 58.6848 8.84882 60.4326 9.57245L60.5127 9.60752C62.9774 10.7572 63.167 14.8732 62.8397 17.233C62.833 17.3422 62.8027 17.4488 62.7509 17.545C62.6991 17.6412 62.6272 17.7248 62.5401 17.7899H51.7465L51.769 19.4663C51.769 20.0142 52.3851 20.7128 53.0036 20.7128H62.0719V23.8936C58.9983 23.9831 56.1278 24.0811 53.2608 23.892C49.7929 23.6631 48.5709 22.1153 48.36 18.696C48.1892 15.9263 47.8484 10.8789 50.834 9.58227ZM58.4136 12.3279C57.6454 12.0978 53.6536 12.106 52.8557 12.3107C52.5869 12.3778 52.3423 12.5203 52.15 12.7216C51.9578 12.9229 51.8257 13.1748 51.769 13.4485C51.686 13.9479 51.7465 14.6412 51.769 15.1677L51.7748 15.2971H59.4525L59.4729 15.123C59.4808 14.1685 59.6066 12.6854 58.4136 12.3279Z"
          fill={lettersFill}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M27.9705 9.10792C29.7435 9.10792 31.6562 10.4179 32.246 12.0983C33.1777 14.7525 32.7254 19.0422 29.7193 20.1532L32.2706 23.8936H28.5667L26.3528 20.4551H21.8828V23.8936H18.562V9.10792H27.9705ZM21.8825 12.2885V17.2738H26.9484C29.0071 17.2738 29.4506 15.6535 29.1968 13.8862C29.0757 13.043 28.2116 12.288 27.3741 12.288L21.8825 12.2885Z"
          fill={lettersFill}
        />
        <path
          d="M68.6706 9.10792L73.8631 17.4462L78.8882 9.10792H82.6772V23.8927H79.3565V14.3641L75.0483 21.4901L72.6477 21.4676L68.2874 14.4375V23.8936H64.9667V9.10792H68.6706Z"
          fill={lettersFill}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M6.64125 9.15071L10.4308 9.1928L17.0292 23.8934H13.2828L12.2875 21.4838L4.67431 21.54L3.74712 23.8934H0L6.64125 9.15071ZM5.87513 18.822H11.1545L8.56095 12.1643L5.87513 18.822Z"
          fill={lettersFill}
        />
        <path
          d="M46.7455 9.10792V12.2884H42.1263V23.8934H38.6566V12.2884H33.9735V9.10792H46.7455Z"
          fill={lettersFill}
        />
        <path
          d="M91.2263 9.13267C91.3855 9.13277 91.5432 9.16449 91.6903 9.22611C91.8374 9.28774 91.9709 9.37807 92.0835 9.49184L96.9973 14.4528C97.11 14.5664 97.1995 14.7014 97.2605 14.8499C97.3216 14.9984 97.353 15.1576 97.3531 15.3184V21.3639H94.2224V14.8594C94.2224 14.179 93.9547 13.5265 93.4781 13.0454C93.0016 12.5643 92.3553 12.2941 91.6814 12.294H85.2388V9.13338L91.2263 9.13267Z"
          fill="#02FFD8"
        />
        <path
          d="M97.4161 0V6.50444C97.416 6.84135 97.4817 7.17498 97.6094 7.48626C97.737 7.79754 97.9243 8.0804 98.1602 8.31866C98.3962 8.55691 98.6764 8.74587 98.9847 8.8748C99.293 9.00373 99.6235 9.07011 99.9572 9.0701H106.4V12.2308H100.412C100.09 12.2304 99.7823 12.1012 99.5552 11.8716L94.6412 6.91103C94.5284 6.79744 94.439 6.66248 94.3779 6.51398C94.3169 6.36548 94.2855 6.20629 94.2854 6.04552V0H97.4161Z"
          fill="#02FFD8"
        />
      </g>
      <defs>
        <clipPath id="clip0_143_305">
          <rect width="106.4" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}
